import { render, staticRenderFns } from "./FilmFooter.vue?vue&type=template&id=73d1684b"
import script from "./FilmFooter.vue?vue&type=script&lang=js"
export * from "./FilmFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports